import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
/*
 * Copyright (C) 2015 - 2018 Kosmos contact@kosmos.fr
 *
 * Projet: eprivacy
 * Version: 7.3.0-ALPHA-3
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *         http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import React from 'react';
import AppList from './app-list';
import CategorizedAppList from './categorized-app-list';
var Apps = /*#__PURE__*/function (_React$Component) {
  function Apps(props, context) {
    var _this;
    _classCallCheck(this, Apps);
    _this = _callSuper(this, Apps, [props, context]);
    props.manager.watch(_this);
    _this.state = {
      consents: props.manager.consents
    };
    return _this;
  }
  _inherits(Apps, _React$Component);
  return _createClass(Apps, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var manager = this.props.manager;
      manager.unwatch(this);
    }
  }, {
    key: "update",
    value: function update(obj, type, data) {
      var manager = this.props.manager;
      if (obj == manager && type == 'consents') this.setState({
        consents: data
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
        config = _this$props.config,
        t = _this$props.t,
        ns = _this$props.ns,
        manager = _this$props.manager;
      var consents = this.state.consents;
      var apps = config.apps,
        categories = config.categories;
      var toggleAll = function toggleAll(value) {
        apps.map(function (app) {
          manager.updateConsent(app, value);
        });
      };
      var enableAll = function enableAll() {
        return toggleAll(true);
      };
      var disableAll = function disableAll() {
        return toggleAll(false);
      };
      var allDisabled = apps.filter(function (app) {
        return app.required || false ? false : consents[app.name];
      }).length === 0;
      var allEnabled = apps.filter(function (app) {
        return consents[app.name];
      }).length === apps.length;
      var someOptional = apps.some(function (app) {
        return !app.required;
      });
      return /*#__PURE__*/React.createElement("div", null, someOptional ? /*#__PURE__*/React.createElement("div", {
        className: ns('AppToggles')
      }, /*#__PURE__*/React.createElement("button", {
        type: "button",
        className: ns('Button Button--info AppToggles-button AppToggles-enableAll'),
        disabled: allEnabled,
        onClick: enableAll
      }, t(['acceptAll'])), /*#__PURE__*/React.createElement("button", {
        type: "button",
        className: ns('Button Button--info AppToggles-button AppToggles-disableAll'),
        disabled: allDisabled,
        onClick: disableAll
      }, t(['declineAll']))) : null, categories ? /*#__PURE__*/React.createElement(CategorizedAppList, {
        t: t,
        ns: ns,
        categories: categories,
        apps: apps,
        consents: consents,
        onToggle: manager.updateConsent.bind(manager)
      }) : /*#__PURE__*/React.createElement(AppList, {
        t: t,
        ns: ns,
        apps: apps,
        consents: consents,
        onToggle: manager.updateConsent.bind(manager)
      }));
    }
  }]);
}(React.Component);
export { Apps as default };